export const DATA_EVENT_PREFIX = 'data-vars-event'

export const DATA_TYPE = `${DATA_EVENT_PREFIX}-type`

export const DATA_VALUE = `${DATA_EVENT_PREFIX}-value`

export const DATA_MISC_JSON = `${DATA_EVENT_PREFIX}-misc-json`

export const DATA_EVENT_CLICKABLE = `${DATA_EVENT_PREFIX}-clickable`

export const DATA_EVENT_SCROLLABLE = `${DATA_EVENT_PREFIX}-scrollable`
